import {gsap} from 'gsap'
import {winsize, isAllMobileDevices} from './bundle.js'

class ScrollDown{
    constructor(scrollDown, target = winsize.height){
        this.scrollDown = scrollDown
        // console.log(this.scrollDown)
        this.isScrolling = false

        this.target = target
        this.offset = 0
        this.awdScroll 
        this.initEvents()
    }


    initEvents(){
        this.showScrollDown()
        this.clickToScrollDown()
        // this.hideScrollDown()
    }

    showScrollDown(){
        gsap.to(this.scrollDown, {
            duration: 1.2,
            autoAlpha: 1,
            ease: 'power1.in'
        })
        gsap.to(this.scrollDown, {
            duration: 1.2,
            y: 0,
            ease: 'power2.out',
            onComplete: () => {
                //Mobile
                if(isAllMobileDevices){
                    this.scrollDown.classList.add('active-for-touch-devices')
                }
            }
        })

    }
    updateScroller(awdScrollUpdated){
        this.awdScroll = awdScrollUpdated
        this.layoutDirection = document.querySelector('html').getAttribute('data-scroll-direction')
        this.awdScroll.on('scroll', (instance) => {
            this.hideScrollDown(instance)
        })
    }    

    hideScrollDown(instance){
        if(instance.scroll.y > 10 && instance.direction === 'down'){
            gsap.to(this.scrollDown, {
                autoAlpha: 0
            })
        }
        if(instance.scroll.x > 10 && instance.direction === 'right'){
            gsap.to(this.scrollDown, {
                autoAlpha: 0
            })
        }
    }

	clickToScrollDown(){
        // var $ = jQuery
		this.scrollDown.addEventListener('click', () => {
            if(!isAllMobileDevices){
                if(this.isScrolling) return
                this.isScrolling = true
            }
			// let target = hh;
			let options = {
				offset: this.offset,
				duration: 1200,
				easing: [0.62, 0.02, 0.38, 0.98],
				callback: () => {
					this.isScrolling = false
				}
			}
            if(!isAllMobileDevices){
                // console.log('non è mobile')
                this.awdScroll.scrollTo(this.target,options)
            }
            else{
                // let target = this.target.offsetTop
            //     console.log('target ', this.target)
            //     $('html, body').animate({
            //         scrollTop: this.target,
            //       },
            //       {
            //         easing: 'linear',
            //         duration: 1200,
            //         complete: function(){

            //        }
            //    });
               gsap.to(window, {
                   duration: 1.2,
                   ease: 'power2.inOut',
                   scrollTo: this.target
       
               })     

            }

		})
	}

}

export {ScrollDown}
